var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoocommerce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "860px",
    height: "900px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f6f6",
    d: "M -0.5,-0.5 C 286.167,-0.5 572.833,-0.5 859.5,-0.5C 859.5,299.5 859.5,599.5 859.5,899.5C 572.833,899.5 286.167,899.5 -0.5,899.5C -0.5,599.5 -0.5,299.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b5d8f",
    d: "M 487.5,43.5 C 491.567,45.0538 495.9,45.7204 500.5,45.5C 636.315,74.1683 734.482,150.835 795,275.5C 801.021,289.204 806.188,303.204 810.5,317.5C 810.41,320.152 811.076,322.485 812.5,324.5C 839.988,420.068 833.821,513.401 794,604.5C 733.786,728.863 635.953,805.196 500.5,833.5C 495.9,833.28 491.567,833.946 487.5,835.5C 446.441,841.106 405.441,840.773 364.5,834.5C 360.274,832.044 355.607,831.044 350.5,831.5C 233.482,805.937 144.315,741.937 83,639.5C 27.5473,539.543 15.3806,434.543 46.5,324.5C 47.9238,322.485 48.5905,320.152 48.5,317.5C 85.6063,208.224 155.94,128.058 259.5,77C 332.146,43.5078 408.146,32.3411 487.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dccad9",
    d: "M 487.5,43.5 C 492.1,43.2796 496.433,43.9462 500.5,45.5C 495.9,45.7204 491.567,45.0538 487.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfb1c9",
    d: "M 660.5,303.5 C 506.168,302.168 351.835,302.168 197.5,303.5C 273.33,302.167 349.497,301.5 426,301.5C 502.167,301.667 578.333,301.833 654.5,302C 656.708,302.191 658.708,302.691 660.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfe",
    d: "M 660.5,303.5 C 673.905,306.958 684.738,314.292 693,325.5C 693.49,326.793 693.657,328.127 693.5,329.5C 694.65,332.298 695.983,334.965 697.5,337.5C 697.971,339.579 698.637,341.579 699.5,343.5C 699.803,405.846 699.47,468.179 698.5,530.5C 698.5,531.167 698.5,531.833 698.5,532.5C 696.835,536.388 695.168,540.388 693.5,544.5C 692.207,546.808 690.874,549.142 689.5,551.5C 684.418,556.919 678.751,561.586 672.5,565.5C 669.728,565.759 667.395,566.759 665.5,568.5C 661.64,568.808 657.974,569.475 654.5,570.5C 654.5,570.833 654.5,571.167 654.5,571.5C 600.5,571.5 546.5,571.5 492.5,571.5C 492.263,572.791 492.596,573.791 493.5,574.5C 496.683,582.713 499.683,591.046 502.5,599.5C 502.955,603.814 504.621,607.481 507.5,610.5C 508.11,611.391 508.443,612.391 508.5,613.5C 508.377,616.588 509.377,619.255 511.5,621.5C 511.043,622.298 510.376,622.631 509.5,622.5C 506.464,620.774 503.464,619.107 500.5,617.5C 500.027,616.094 499.027,615.427 497.5,615.5C 471.043,601.437 444.71,587.104 418.5,572.5C 418.5,571.833 418.167,571.5 417.5,571.5C 343.99,570.808 270.323,570.142 196.5,569.5C 179.77,564.439 168.103,553.773 161.5,537.5C 160.911,532.519 160.411,527.519 160,522.5C 159.5,464.834 159.333,407.168 159.5,349.5C 159.5,346.833 159.5,344.167 159.5,341.5C 159.833,340.167 160.167,338.833 160.5,337.5C 162.017,334.965 163.35,332.298 164.5,329.5C 167.278,321.716 172.278,315.716 179.5,311.5C 185.139,309.133 190.472,306.466 195.5,303.5C 196.167,303.5 196.833,303.5 197.5,303.5C 351.835,302.168 506.168,302.168 660.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ddc8d9",
    d: "M 195.5,303.5 C 190.472,306.466 185.139,309.133 179.5,311.5C 182.133,308.889 185.133,306.722 188.5,305C 190.866,304.56 193.199,304.06 195.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ba91b2",
    d: "M 48.5,317.5 C 48.5905,320.152 47.9238,322.485 46.5,324.5C 46.4095,321.848 47.0762,319.515 48.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ba90b2",
    d: "M 810.5,317.5 C 811.924,319.515 812.59,321.848 812.5,324.5C 811.076,322.485 810.41,320.152 810.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4b9ce",
    d: "M 164.5,329.5 C 163.35,332.298 162.017,334.965 160.5,337.5C 160.259,333.981 161.593,331.315 164.5,329.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#caa9c3",
    d: "M 396.5,332.5 C 391.77,332.283 387.103,332.617 382.5,333.5C 382.611,332.883 382.944,332.383 383.5,332C 388.02,331.186 392.354,331.353 396.5,332.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9c1d3",
    d: "M 693.5,329.5 C 696.407,331.315 697.741,333.981 697.5,337.5C 695.983,334.965 694.65,332.298 693.5,329.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b5d8f",
    d: "M 396.5,332.5 C 401.729,334.891 405.895,338.558 409,343.5C 409.698,348.97 409.198,354.303 407.5,359.5C 405.416,362.053 404.083,365.053 403.5,368.5C 401.482,373.067 399.649,377.734 398,382.5C 397.498,385.513 396.998,388.513 396.5,391.5C 393.716,397.418 392.05,403.751 391.5,410.5C 389.856,415.697 388.856,421.03 388.5,426.5C 387.076,428.515 386.41,430.848 386.5,433.5C 386.5,434.167 386.5,434.833 386.5,435.5C 385.778,435.918 385.278,436.584 385,437.5C 384.301,443.489 383.801,449.489 383.5,455.5C 382.468,462.122 381.801,468.788 381.5,475.5C 380.527,477.948 380.194,480.615 380.5,483.5C 379.698,484.952 379.198,486.618 379,488.5C 378.774,504.858 378.274,521.191 377.5,537.5C 376.662,537.842 376.328,538.508 376.5,539.5C 374.5,540.833 372.833,542.5 371.5,544.5C 370.508,544.328 369.842,544.662 369.5,545.5C 365.434,545.693 361.434,545.36 357.5,544.5C 351.641,541.154 346.474,536.82 342,531.5C 329.155,514.832 318.655,496.832 310.5,477.5C 310.554,474.008 309.554,471.008 307.5,468.5C 307.554,465.008 306.554,462.008 304.5,459.5C 303.131,456.702 302.131,453.702 301.5,450.5C 301.753,448.173 301.086,446.173 299.5,444.5C 298.081,445.005 297.415,446.005 297.5,447.5C 294.466,452.24 291.799,457.24 289.5,462.5C 286.459,467.94 283.792,473.607 281.5,479.5C 279.801,481.566 278.468,483.9 277.5,486.5C 276.069,487.78 275.402,489.447 275.5,491.5C 273.801,493.566 272.468,495.9 271.5,498.5C 270.069,499.78 269.402,501.447 269.5,503.5C 267.801,505.566 266.468,507.9 265.5,510.5C 261.01,519.41 255.51,527.743 249,535.5C 245.134,541.007 239.967,544.34 233.5,545.5C 231.366,545.485 229.366,544.985 227.5,544C 219.323,534.32 214.323,523.153 212.5,510.5C 212.241,507.728 211.241,505.395 209.5,503.5C 209.768,501.901 209.434,500.568 208.5,499.5C 208.59,496.848 207.924,494.515 206.5,492.5C 206.784,490.585 206.451,488.919 205.5,487.5C 204.584,481.949 203.25,476.615 201.5,471.5C 199.541,463.616 198.207,455.616 197.5,447.5C 197.048,443.837 196.548,440.17 196,436.5C 195.617,435.944 195.117,435.611 194.5,435.5C 194.5,435.167 194.5,434.833 194.5,434.5C 194.59,431.848 193.924,429.515 192.5,427.5C 192.5,426.833 192.5,426.167 192.5,425.5C 191.935,420.851 191.435,416.184 191,411.5C 190.617,410.944 190.117,410.611 189.5,410.5C 189.5,409.5 189.5,408.5 189.5,407.5C 189.001,403.51 188.501,399.51 188,395.5C 187.722,394.584 187.222,393.918 186.5,393.5C 186.151,386.073 185.151,378.74 183.5,371.5C 182.253,364.48 182.253,357.48 183.5,350.5C 184.95,347.215 187.283,344.715 190.5,343C 205.646,337.403 214.979,342.236 218.5,357.5C 218.676,360.727 219.343,363.727 220.5,366.5C 221.601,372.072 222.268,377.738 222.5,383.5C 223.065,388.149 223.565,392.816 224,397.5C 224.383,398.056 224.883,398.389 225.5,398.5C 225.337,400.857 225.503,403.19 226,405.5C 226.383,406.056 226.883,406.389 227.5,406.5C 229.697,420.157 232.031,433.824 234.5,447.5C 234.259,449.898 234.926,451.898 236.5,453.5C 236.5,453.833 236.5,454.167 236.5,454.5C 236.77,459.45 237.77,464.117 239.5,468.5C 239.222,470.346 239.889,471.68 241.5,472.5C 243.795,468.903 245.795,465.237 247.5,461.5C 249.975,460.313 250.975,458.313 250.5,455.5C 251.5,453.5 252.5,451.5 253.5,449.5C 255.822,448.198 257.155,446.198 257.5,443.5C 257.461,440.911 258.461,438.911 260.5,437.5C 262.245,435.967 263.245,433.967 263.5,431.5C 265.744,425.341 268.744,419.675 272.5,414.5C 274.245,412.967 275.245,410.967 275.5,408.5C 278.78,405.612 280.78,401.945 281.5,397.5C 285.073,388.732 289.739,380.565 295.5,373C 304.912,367.563 313.412,368.73 321,376.5C 322.128,378.345 322.628,380.345 322.5,382.5C 323.34,386.985 324.34,391.319 325.5,395.5C 326.434,396.568 326.768,397.901 326.5,399.5C 326.259,401.898 326.926,403.898 328.5,405.5C 328.549,409.078 329.215,412.411 330.5,415.5C 329.886,420.069 330.886,424.069 333.5,427.5C 336.29,436.298 338.957,445.298 341.5,454.5C 344.319,466.101 345.985,466.101 346.5,454.5C 346.5,453.833 346.5,453.167 346.5,452.5C 347.117,452.389 347.617,452.056 348,451.5C 348.391,446.146 348.891,440.812 349.5,435.5C 349.838,428.797 350.505,422.13 351.5,415.5C 352.434,414.432 352.768,413.099 352.5,411.5C 354.342,407.841 355.342,403.841 355.5,399.5C 355.608,394.295 356.608,389.295 358.5,384.5C 359.973,382.417 361.14,380.084 362,377.5C 362.61,374.173 363.11,370.839 363.5,367.5C 363.833,366.167 364.167,364.833 364.5,363.5C 367.86,359.93 369.527,355.597 369.5,350.5C 370.167,350.5 370.5,350.167 370.5,349.5C 372.245,347.967 373.245,345.967 373.5,343.5C 375.105,338.896 378.105,335.562 382.5,333.5C 387.103,332.617 391.77,332.283 396.5,332.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c29bba",
    d: "M 373.5,343.5 C 373.245,345.967 372.245,347.967 370.5,349.5C 370.755,347.033 371.755,345.033 373.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0e6ef",
    d: "M 159.5,349.5 C 159.333,407.168 159.5,464.834 160,522.5C 160.411,527.519 160.911,532.519 161.5,537.5C 160.076,535.485 159.41,533.152 159.5,530.5C 158.192,470.012 158.192,409.678 159.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccabc6",
    d: "M 485.5,356.5 C 478.798,356.336 472.131,356.669 465.5,357.5C 465.918,356.778 466.584,356.278 467.5,356C 473.681,355.181 479.681,355.347 485.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbaac5",
    d: "M 625.5,356.5 C 616.779,356.225 608.113,356.558 599.5,357.5C 599.611,356.883 599.944,356.383 600.5,356C 609.01,355.177 617.344,355.343 625.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b5d8f",
    d: "M 485.5,356.5 C 488.279,356.279 490.946,356.612 493.5,357.5C 495.102,359.074 497.102,359.741 499.5,359.5C 518.791,368.072 530.458,382.739 534.5,403.5C 534.676,406.727 535.343,409.727 536.5,412.5C 536.341,425.203 535.674,437.87 534.5,450.5C 534.5,450.833 534.5,451.167 534.5,451.5C 532.861,454.87 531.861,458.537 531.5,462.5C 531.405,464.786 530.738,466.786 529.5,468.5C 527.759,470.395 526.759,472.728 526.5,475.5C 525.89,476.391 525.557,477.391 525.5,478.5C 523.801,480.566 522.468,482.9 521.5,485.5C 514.896,498.036 505.563,508.036 493.5,515.5C 491.033,515.755 489.033,516.755 487.5,518.5C 483.508,518.764 479.841,519.764 476.5,521.5C 470.5,521.5 464.5,521.5 458.5,521.5C 456.485,520.076 454.152,519.41 451.5,519.5C 443.482,517.323 436.482,513.323 430.5,507.5C 429.167,505.5 427.5,503.833 425.5,502.5C 419.431,493.63 415.097,483.963 412.5,473.5C 411.949,470.193 411.616,466.86 411.5,463.5C 411.5,453.167 411.5,442.833 411.5,432.5C 411.782,428.426 412.448,424.426 413.5,420.5C 414.946,417.746 415.946,414.746 416.5,411.5C 417.167,409.5 417.833,407.5 418.5,405.5C 420.245,403.967 421.245,401.967 421.5,399.5C 422.326,396.515 423.659,393.849 425.5,391.5C 426.906,391.027 427.573,390.027 427.5,388.5C 429.529,383.776 432.529,379.776 436.5,376.5C 438.5,375.167 440.167,373.5 441.5,371.5C 445.248,366.126 450.248,362.459 456.5,360.5C 459.746,359.946 462.746,358.946 465.5,357.5C 472.131,356.669 478.798,356.336 485.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9c1d5",
    d: "M 493.5,357.5 C 495.898,357.259 497.898,357.926 499.5,359.5C 497.102,359.741 495.102,359.074 493.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b5d8f",
    d: "M 625.5,356.5 C 628.671,358.717 632.337,359.884 636.5,360C 639.712,362.12 643.045,363.954 646.5,365.5C 648.239,368.243 650.573,370.243 653.5,371.5C 660.754,380.005 665.92,389.672 669,400.5C 670.161,406.468 670.994,412.468 671.5,418.5C 672.093,436.727 669.427,454.393 663.5,471.5C 661.805,473.897 660.472,476.563 659.5,479.5C 657.755,481.033 656.755,483.033 656.5,485.5C 651.924,492.752 646.924,499.752 641.5,506.5C 638.883,507.786 636.55,509.453 634.5,511.5C 632.305,514.435 629.305,516.102 625.5,516.5C 620.948,518.465 616.281,519.798 611.5,520.5C 599.721,520.982 588.387,519.315 577.5,515.5C 574.411,514.261 571.411,512.761 568.5,511C 563.553,506.225 559.22,501.058 555.5,495.5C 555.245,493.033 554.245,491.033 552.5,489.5C 549.221,481.084 546.888,472.417 545.5,463.5C 545.197,451.097 545.864,438.764 547.5,426.5C 550.288,410.078 556.455,395.078 566,381.5C 568.952,377.901 572.118,374.567 575.5,371.5C 577.749,370.92 579.415,369.587 580.5,367.5C 580.953,366.542 581.619,365.708 582.5,365C 585.614,363.583 588.614,362.083 591.5,360.5C 593.967,360.245 595.967,359.245 597.5,357.5C 598.167,357.5 598.833,357.5 599.5,357.5C 608.113,356.558 616.779,356.225 625.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfb0c9",
    d: "M 597.5,357.5 C 595.967,359.245 593.967,360.245 591.5,360.5C 593.033,358.755 595.033,357.755 597.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be95b6",
    d: "M 369.5,350.5 C 369.527,355.597 367.86,359.93 364.5,363.5C 366.325,359.174 367.992,354.841 369.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdaec7",
    d: "M 465.5,357.5 C 462.746,358.946 459.746,359.946 456.5,360.5C 459.008,358.446 462.008,357.446 465.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0b3cb",
    d: "M 183.5,350.5 C 182.253,357.48 182.253,364.48 183.5,371.5C 182.778,371.082 182.278,370.416 182,369.5C 181.333,363.5 181.333,357.5 182,351.5C 182.383,350.944 182.883,350.611 183.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9c1d5",
    d: "M 218.5,357.5 C 220.265,360.123 220.932,363.123 220.5,366.5C 219.343,363.727 218.676,360.727 218.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dac2d5",
    d: "M 646.5,365.5 C 649.427,366.757 651.761,368.757 653.5,371.5C 650.573,370.243 648.239,368.243 646.5,365.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbc5d7",
    d: "M 407.5,359.5 C 407.657,360.873 407.49,362.207 407,363.5C 406.098,365.431 404.931,367.097 403.5,368.5C 404.083,365.053 405.416,362.053 407.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb91b2",
    d: "M 580.5,367.5 C 579.415,369.587 577.749,370.92 575.5,371.5C 576.585,369.413 578.251,368.08 580.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c39cbb",
    d: "M 441.5,371.5 C 440.167,373.5 438.5,375.167 436.5,376.5C 437.167,373.833 438.833,372.167 441.5,371.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b586ab",
    d: "M 363.5,367.5 C 363.11,370.839 362.61,374.173 362,377.5C 361.14,380.084 359.973,382.417 358.5,384.5C 358.812,378.283 360.478,372.617 363.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c099b9",
    d: "M 322.5,382.5 C 325.035,386.355 326.035,390.688 325.5,395.5C 324.34,391.319 323.34,386.985 322.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccacc6",
    d: "M 427.5,388.5 C 427.573,390.027 426.906,391.027 425.5,391.5C 425.427,389.973 426.094,388.973 427.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7bed2",
    d: "M 618.5,393.5 C 614.019,393.425 609.686,394.092 605.5,395.5C 609.548,392.62 613.881,391.954 618.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dec9da",
    d: "M 485.5,394.5 C 481.486,394.334 477.486,394.501 473.5,395C 471.595,396.421 469.595,397.588 467.5,398.5C 471.602,393.409 476.936,391.576 483.5,393C 484.416,393.278 485.082,393.778 485.5,394.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 485.5,394.5 C 489.404,395.403 492.071,397.736 493.5,401.5C 493.77,405.358 495.103,408.691 497.5,411.5C 498.309,413.028 498.976,414.694 499.5,416.5C 499.716,425.533 499.383,434.533 498.5,443.5C 498.5,444.167 498.5,444.833 498.5,445.5C 496.926,447.102 496.259,449.102 496.5,451.5C 494.252,455.142 492.919,459.142 492.5,463.5C 489.04,467.055 486.04,471.055 483.5,475.5C 479.914,478.571 475.914,481.071 471.5,483C 464.676,484.945 459.176,483.112 455,477.5C 451.941,471.824 449.775,465.824 448.5,459.5C 448.41,449.482 448.743,439.482 449.5,429.5C 452.203,417.158 458.203,406.825 467.5,398.5C 469.595,397.588 471.595,396.421 473.5,395C 477.486,394.501 481.486,394.334 485.5,394.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfcfd",
    d: "M 618.5,393.5 C 624.185,395.185 627.852,398.852 629.5,404.5C 629.755,406.967 630.755,408.967 632.5,410.5C 632.674,412.861 633.007,415.194 633.5,417.5C 634.778,426.503 634.778,435.503 633.5,444.5C 632.076,446.515 631.41,448.848 631.5,451.5C 627.548,463.975 620.215,474.142 609.5,482C 602.472,484.819 596.306,483.652 591,478.5C 586.328,471.142 583.495,463.142 582.5,454.5C 582.523,446.817 582.857,439.15 583.5,431.5C 584.924,429.485 585.59,427.152 585.5,424.5C 587.241,422.605 588.241,420.272 588.5,417.5C 591.912,408.422 597.579,401.088 605.5,395.5C 609.686,394.092 614.019,393.425 618.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b587ac",
    d: "M 222.5,383.5 C 224.265,386.123 224.932,389.123 224.5,392.5C 224.517,394.565 224.85,396.565 225.5,398.5C 224.883,398.389 224.383,398.056 224,397.5C 223.565,392.816 223.065,388.149 222.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc91b3",
    d: "M 281.5,397.5 C 280.78,401.945 278.78,405.612 275.5,408.5C 277.133,404.571 279.133,400.904 281.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4b8ce",
    d: "M 326.5,399.5 C 328.074,401.102 328.741,403.102 328.5,405.5C 326.926,403.898 326.259,401.898 326.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c29aba",
    d: "M 355.5,399.5 C 355.342,403.841 354.342,407.841 352.5,411.5C 352.77,407.184 353.77,403.184 355.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdacc6",
    d: "M 421.5,399.5 C 421.245,401.967 420.245,403.967 418.5,405.5C 418.755,403.033 419.755,401.033 421.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc5d7",
    d: "M 493.5,401.5 C 494.751,403.382 495.918,405.382 497,407.5C 497.49,408.793 497.657,410.127 497.5,411.5C 495.103,408.691 493.77,405.358 493.5,401.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7bdd2",
    d: "M 224.5,392.5 C 225.222,392.918 225.722,393.584 226,394.5C 226.501,398.51 227.001,402.51 227.5,406.5C 226.883,406.389 226.383,406.056 226,405.5C 225.503,403.19 225.337,400.857 225.5,398.5C 224.85,396.565 224.517,394.565 224.5,392.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0cbdc",
    d: "M 186.5,393.5 C 187.222,393.918 187.722,394.584 188,395.5C 188.501,399.51 189.001,403.51 189.5,407.5C 187.584,403.282 186.584,398.615 186.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc6d8",
    d: "M 396.5,391.5 C 395.611,398.147 393.944,404.48 391.5,410.5C 392.05,403.751 393.716,397.418 396.5,391.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#caa8c3",
    d: "M 629.5,404.5 C 631.245,406.033 632.245,408.033 632.5,410.5C 630.755,408.967 629.755,406.967 629.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7bed2",
    d: "M 534.5,403.5 C 535.117,403.611 535.617,403.944 536,404.5C 536.497,407.146 536.664,409.813 536.5,412.5C 535.343,409.727 534.676,406.727 534.5,403.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c39dbb",
    d: "M 275.5,408.5 C 275.245,410.967 274.245,412.967 272.5,414.5C 272.755,412.033 273.755,410.033 275.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9c1d5",
    d: "M 416.5,411.5 C 415.946,414.746 414.946,417.746 413.5,420.5C 413.446,417.008 414.446,414.008 416.5,411.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccaac6",
    d: "M 699.5,343.5 C 700.665,404.665 700.832,465.999 700,527.5C 699.768,528.737 699.268,529.737 698.5,530.5C 699.47,468.179 699.803,405.846 699.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd94b5",
    d: "M 330.5,415.5 C 332.027,419.267 333.027,423.267 333.5,427.5C 330.886,424.069 329.886,420.069 330.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c7a3c0",
    d: "M 588.5,417.5 C 588.241,420.272 587.241,422.605 585.5,424.5C 585.759,421.728 586.759,419.395 588.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7bdd1",
    d: "M 189.5,410.5 C 190.117,410.611 190.617,410.944 191,411.5C 191.435,416.184 191.935,420.851 192.5,425.5C 191.778,425.082 191.278,424.416 191,423.5C 190.417,419.168 189.917,414.835 189.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9a7c2",
    d: "M 536.5,412.5 C 537.568,424.015 537.402,435.682 536,447.5C 535.768,448.737 535.268,449.737 534.5,450.5C 535.674,437.87 536.341,425.203 536.5,412.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c19ab9",
    d: "M 499.5,416.5 C 500.166,420.82 500.499,425.32 500.5,430C 500.493,434.886 499.826,439.386 498.5,443.5C 499.383,434.533 499.716,425.533 499.5,416.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cba9c4",
    d: "M 633.5,417.5 C 636.167,426.5 636.167,435.5 633.5,444.5C 634.778,435.503 634.778,426.503 633.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3d1e0",
    d: "M 351.5,415.5 C 350.505,422.13 349.838,428.797 349.5,435.5C 349.167,435.5 348.833,435.5 348.5,435.5C 348.428,429.455 348.928,423.455 350,417.5C 350.278,416.584 350.778,415.918 351.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c29cbb",
    d: "M 388.5,426.5 C 388.59,429.152 387.924,431.485 386.5,433.5C 386.41,430.848 387.076,428.515 388.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4b9cf",
    d: "M 192.5,427.5 C 193.924,429.515 194.59,431.848 194.5,434.5C 193.076,432.485 192.41,430.152 192.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6d5e2",
    d: "M 671.5,418.5 C 672.657,426.99 672.824,435.657 672,444.5C 670.268,449.35 669.268,454.35 669,459.5C 667.456,463.774 665.622,467.774 663.5,471.5C 669.427,454.393 672.093,436.727 671.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf97b7",
    d: "M 263.5,431.5 C 263.245,433.967 262.245,435.967 260.5,437.5C 260.755,435.033 261.755,433.033 263.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c19ab9",
    d: "M 547.5,426.5 C 545.864,438.764 545.197,451.097 545.5,463.5C 544.341,453.342 544.175,443.008 545,432.5C 546.019,430.498 546.852,428.498 547.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebdde8",
    d: "M 449.5,429.5 C 448.743,439.482 448.41,449.482 448.5,459.5C 447.343,450.676 447.176,441.676 448,432.5C 448.232,431.263 448.732,430.263 449.5,429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c39cbb",
    d: "M 159.5,341.5 C 159.5,344.167 159.5,346.833 159.5,349.5C 158.192,409.678 158.192,470.012 159.5,530.5C 158.71,529.391 158.21,528.058 158,526.5C 157.333,465.167 157.333,403.833 158,342.5C 158.383,341.944 158.883,341.611 159.5,341.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5bacf",
    d: "M 583.5,431.5 C 582.857,439.15 582.523,446.817 582.5,454.5C 581.836,451.854 581.502,449.021 581.5,446C 581.405,440.921 582.072,436.088 583.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9a6c2",
    d: "M 257.5,443.5 C 257.155,446.198 255.822,448.198 253.5,449.5C 254.34,447.147 255.674,445.147 257.5,443.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c19aba",
    d: "M 194.5,435.5 C 195.117,435.611 195.617,435.944 196,436.5C 196.548,440.17 197.048,443.837 197.5,447.5C 195.658,443.841 194.658,439.841 194.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9bfd3",
    d: "M 301.5,450.5 C 300.442,449.4 299.608,448.066 299,446.5C 298.617,447.056 298.117,447.389 297.5,447.5C 297.415,446.005 298.081,445.005 299.5,444.5C 301.086,446.173 301.753,448.173 301.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b789ae",
    d: "M 348.5,435.5 C 348.833,435.5 349.167,435.5 349.5,435.5C 348.891,440.812 348.391,446.146 348,451.5C 347.617,452.056 347.117,452.389 346.5,452.5C 346.968,446.671 347.635,441.004 348.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b688ad",
    d: "M 386.5,435.5 C 385.614,442.141 384.947,448.808 384.5,455.5C 384.167,455.5 383.833,455.5 383.5,455.5C 383.801,449.489 384.301,443.489 385,437.5C 385.278,436.584 385.778,435.918 386.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b98db1",
    d: "M 411.5,432.5 C 411.5,442.833 411.5,453.167 411.5,463.5C 411.167,463.5 410.833,463.5 410.5,463.5C 409.834,459.681 409.501,455.681 409.5,451.5C 409.361,444.935 410.028,438.601 411.5,432.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6a2bf",
    d: "M 498.5,445.5 C 498.741,447.898 498.074,449.898 496.5,451.5C 496.259,449.102 496.926,447.102 498.5,445.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c29bbb",
    d: "M 633.5,444.5 C 633.59,447.152 632.924,449.485 631.5,451.5C 631.41,448.848 632.076,446.515 633.5,444.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c097b8",
    d: "M 234.5,447.5 C 236.074,449.102 236.741,451.102 236.5,453.5C 234.926,451.898 234.259,449.898 234.5,447.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2d0de",
    d: "M 297.5,447.5 C 296.098,453.311 293.431,458.311 289.5,462.5C 291.799,457.24 294.466,452.24 297.5,447.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9a6c1",
    d: "M 534.5,451.5 C 534.11,454.839 533.61,458.173 533,461.5C 532.617,462.056 532.117,462.389 531.5,462.5C 531.861,458.537 532.861,454.87 534.5,451.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be94b5",
    d: "M 250.5,455.5 C 250.975,458.313 249.975,460.313 247.5,461.5C 248.508,459.456 249.508,457.456 250.5,455.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b78aae",
    d: "M 341.5,454.5 C 342.935,455.79 343.935,457.456 344.5,459.5C 345.17,457.709 345.837,456.042 346.5,454.5C 345.985,466.101 344.319,466.101 341.5,454.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c19bba",
    d: "M 236.5,454.5 C 238.23,458.883 239.23,463.55 239.5,468.5C 237.77,464.117 236.77,459.45 236.5,454.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be95b6",
    d: "M 304.5,459.5 C 306.554,462.008 307.554,465.008 307.5,468.5C 306.054,465.746 305.054,462.746 304.5,459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be95b6",
    d: "M 492.5,463.5 C 490.472,468.219 487.472,472.219 483.5,475.5C 486.04,471.055 489.04,467.055 492.5,463.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9c2d4",
    d: "M 410.5,463.5 C 410.833,463.5 411.167,463.5 411.5,463.5C 411.616,466.86 411.949,470.193 412.5,473.5C 411.778,473.082 411.278,472.416 411,471.5C 410.503,468.854 410.336,466.187 410.5,463.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c29cbb",
    d: "M 307.5,468.5 C 309.554,471.008 310.554,474.008 310.5,477.5C 309.054,474.746 308.054,471.746 307.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c49ebd",
    d: "M 529.5,468.5 C 529.241,471.272 528.241,473.605 526.5,475.5C 526.759,472.728 527.759,470.395 529.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8dae5",
    d: "M 383.5,455.5 C 383.833,455.5 384.167,455.5 384.5,455.5C 384.022,463.163 383.522,470.83 383,478.5C 382.722,479.416 382.222,480.082 381.5,480.5C 381.5,478.833 381.5,477.167 381.5,475.5C 381.801,468.788 382.468,462.122 383.5,455.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6d6e3",
    d: "M 201.5,471.5 C 203.25,476.615 204.584,481.949 205.5,487.5C 204.207,486.158 203.374,484.491 203,482.5C 202.452,478.83 201.952,475.163 201.5,471.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9c1d4",
    d: "M 525.5,478.5 C 525.275,481.546 523.942,483.879 521.5,485.5C 522.468,482.9 523.801,480.566 525.5,478.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dac2d4",
    d: "M 281.5,479.5 C 281.275,482.546 279.942,484.879 277.5,486.5C 278.468,483.9 279.801,481.566 281.5,479.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5bad0",
    d: "M 659.5,479.5 C 659.245,481.967 658.245,483.967 656.5,485.5C 656.755,483.033 657.755,481.033 659.5,479.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5b9ce",
    d: "M 552.5,489.5 C 554.245,491.033 555.245,493.033 555.5,495.5C 553.755,493.967 552.755,491.967 552.5,489.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbc3d5",
    d: "M 275.5,491.5 C 275.275,494.546 273.942,496.879 271.5,498.5C 272.468,495.9 273.801,493.566 275.5,491.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc6d7",
    d: "M 206.5,492.5 C 207.924,494.515 208.59,496.848 208.5,499.5C 207.076,497.485 206.41,495.152 206.5,492.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbc4d6",
    d: "M 425.5,502.5 C 427.5,503.833 429.167,505.5 430.5,507.5C 427.833,506.833 426.167,505.167 425.5,502.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc5d7",
    d: "M 381.5,475.5 C 381.5,477.167 381.5,478.833 381.5,480.5C 381.047,496.999 380.381,513.332 379.5,529.5C 379.308,514.149 379.641,498.816 380.5,483.5C 380.194,480.615 380.527,477.948 381.5,475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc5d7",
    d: "M 269.5,503.5 C 269.275,506.546 267.942,508.879 265.5,510.5C 266.468,507.9 267.801,505.566 269.5,503.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c098b8",
    d: "M 209.5,503.5 C 211.241,505.395 212.241,507.728 212.5,510.5C 210.759,508.605 209.759,506.272 209.5,503.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad7aa3",
    d: "M 380.5,483.5 C 379.641,498.816 379.308,514.149 379.5,529.5C 379.706,532.495 379.04,535.162 377.5,537.5C 378.274,521.191 378.774,504.858 379,488.5C 379.198,486.618 379.698,484.952 380.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5bbd0",
    d: "M 641.5,506.5 C 640.008,509.323 637.674,510.99 634.5,511.5C 636.55,509.453 638.883,507.786 641.5,506.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c29cbb",
    d: "M 493.5,515.5 C 492.232,517.047 490.565,518.047 488.5,518.5C 488.167,518.5 487.833,518.5 487.5,518.5C 489.033,516.755 491.033,515.755 493.5,515.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#caa8c3",
    d: "M 625.5,516.5 C 621.498,519.679 616.831,521.345 611.5,521.5C 611.5,521.167 611.5,520.833 611.5,520.5C 616.281,519.798 620.948,518.465 625.5,516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0b3cb",
    d: "M 451.5,519.5 C 454.152,519.41 456.485,520.076 458.5,521.5C 455.848,521.59 453.515,520.924 451.5,519.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1cedd",
    d: "M 487.5,518.5 C 487.833,518.5 488.167,518.5 488.5,518.5C 485.069,521.114 481.069,522.114 476.5,521.5C 479.841,519.764 483.508,518.764 487.5,518.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac78a2",
    d: "M 577.5,515.5 C 588.387,519.315 599.721,520.982 611.5,520.5C 611.5,520.833 611.5,521.167 611.5,521.5C 604.132,521.683 596.799,521.35 589.5,520.5C 584.952,519.885 580.952,518.219 577.5,515.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfcadb",
    d: "M 589.5,520.5 C 596.799,521.35 604.132,521.683 611.5,521.5C 605.013,522.654 598.346,522.821 591.5,522C 590.584,521.722 589.918,521.222 589.5,520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cba9c4",
    d: "M 698.5,532.5 C 697.86,535.865 697.026,539.198 696,542.5C 695.292,543.381 694.458,544.047 693.5,544.5C 695.168,540.388 696.835,536.388 698.5,532.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dac3d5",
    d: "M 376.5,539.5 C 375.833,542.167 374.167,543.833 371.5,544.5C 372.833,542.5 374.5,540.833 376.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3b8ce",
    d: "M 357.5,544.5 C 361.434,545.36 365.434,545.693 369.5,545.5C 366.024,546.643 362.358,546.81 358.5,546C 357.944,545.617 357.611,545.117 357.5,544.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd94b5",
    d: "M 693.5,544.5 C 693.851,547.812 692.518,550.145 689.5,551.5C 690.874,549.142 692.207,546.808 693.5,544.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cba9c4",
    d: "M 672.5,565.5 C 670.605,567.241 668.272,568.241 665.5,568.5C 667.395,566.759 669.728,565.759 672.5,565.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdadc6",
    d: "M 665.5,568.5 C 665.082,569.222 664.416,569.722 663.5,570C 660.518,570.498 657.518,570.665 654.5,570.5C 657.974,569.475 661.64,568.808 665.5,568.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc5d6",
    d: "M 196.5,569.5 C 270.323,570.142 343.99,570.808 417.5,571.5C 344.811,571.821 272.144,571.487 199.5,570.5C 198.209,570.737 197.209,570.404 196.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a56d9a",
    d: "M 199.5,570.5 C 272.144,571.487 344.811,571.821 417.5,571.5C 418.167,571.5 418.5,571.833 418.5,572.5C 346.166,572.667 273.833,572.5 201.5,572C 200.584,571.722 199.918,571.222 199.5,570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a56d9a",
    d: "M 654.5,571.5 C 600.659,571.834 546.992,572.834 493.5,574.5C 492.596,573.791 492.263,572.791 492.5,571.5C 546.5,571.5 600.5,571.5 654.5,571.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7bed2",
    d: "M 502.5,599.5 C 505.425,602.475 507.092,606.142 507.5,610.5C 504.621,607.481 502.955,603.814 502.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccabc5",
    d: "M 497.5,615.5 C 499.027,615.427 500.027,616.094 500.5,617.5C 498.973,617.573 497.973,616.906 497.5,615.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dac2d5",
    d: "M 508.5,613.5 C 509.751,615.382 510.918,617.382 512,619.5C 512.49,620.793 512.657,622.127 512.5,623.5C 511.209,623.737 510.209,623.404 509.5,622.5C 510.376,622.631 511.043,622.298 511.5,621.5C 509.377,619.255 508.377,616.588 508.5,613.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b385aa",
    d: "M 350.5,831.5 C 355.607,831.044 360.274,832.044 364.5,834.5C 359.578,834.13 354.911,833.13 350.5,831.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfcfdc",
    d: "M 500.5,833.5 C 496.433,835.054 492.1,835.72 487.5,835.5C 491.567,833.946 495.9,833.28 500.5,833.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoocommerce);
export default __webpack_public_path__ + "static/media/woocommerce.28f3e3d5d31cb17968ba5ee9dc9e77b2.svg";
export { ForwardRef as ReactComponent };